import React from "react";
import Header from "../directives/header";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
} from "react-bootstrap";
import "../css/home2.css";
import Footer from "../directives/footer";
import ConnectWallent from "../../Common/ConnectWallent";
import config from "../../config/config";
import { useAccount } from 'wagmi';
import { Toaster, toast } from 'react-hot-toast';

const Projectowner = () => {
  const { isConnected } = useAccount();
  const handleRedirectPage = () => {
    if (isConnected) {
      window.location.href = `${config.baseUrl}launchProcess`;
    } else {
      toast.error('Please connect your wallet first')
    }
  };

  return (
    <>
      <div className="home2">
        <Toaster />
        <Header />
        <section className="herobanner position-relative">
          <div className="bgleft position-absolute top-0 bottom-0 start-0">
            <img src="assets/images/shape/bgleftshadow.svg" />
          </div>
          {/* <div className="bgright position-absolute top-0 bottom-0 end-0">
            <img src="assets/images/shape/blueshadow.svg" />
          </div> */}
          <Container className="pt-5 mt-4">
            <Row className="justify-content-center mb-5">
              <Col lg={10} className="text-center px-lg-5">
                <h1 className="text-white fw-bold">FOR PROJECT OWNER</h1>
                <p>
                  we believe that Investors are the backbone of innovation. By
                  providing capital to promising blockchain projects, you help
                  drive technological advancements while earning rewards,
                  governance power, and long-term growth opportunities.
                </p>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col lg={4} md={6} className="mb-4">
                <Card className=" bg-transparent border-0">
                  <Card.Body className="p-0">
                    <div>
                      <div className="blueBox mb-4">
                        <img src="assets/images/icon/support.svg" />
                      </div>
                      <div className="pt-0 z-1">
                        <div className="text-center mb-4">
                          <h4 className="text-white">Showcase Your Project</h4>
                        </div>
                        <ul>
                          <li className="mb-3">
                            Get listed on the UNITRONIX marketplace, reaching a
                            global audience of investors.
                          </li>
                          <li>
                            Share progress updates, milestones, and investment
                            opportunities.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={4} md={6} className="mb-4">
                <Card className="bg-transparent border-0">
                  <Card.Body className="p-0">
                    <div>
                      <div className="blueBox mb-4">
                        <img src="assets/images/icon/support.svg" />
                      </div>
                      <div className="pt-0 z-1">
                        <div className="text-center mb-4">
                          <h4 className="text-white">Engage & Build Trust</h4>
                        </div>
                        <ul>
                          <li className="mb-3">
                            Interact with potential investors through community
                            discussions and AMAs.
                          </li>
                          <li>
                            Offer governance participation, allowing investors
                            to vote on project decisions.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="secure py-0 position-relative z-1">
          <Container>
            <Row className="justify-content-center">
              <Col lg={8} className="mb-4 text-center">
                <div className="heading my-4 ">
                  <h1 className="text-white fw-normal">
                    Secure & Transparent Fundraising
                  </h1>
                </div>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col lg={6} className="mb-5">
                <div>
                  <div className="mb-5">
                    <h4 className="text-white mb-4">
                      Raise Capital Through Smart Contracts :
                    </h4>
                    <ul className="mb-0">
                      <li className="mb-3">
                        Secure funding via blockchain-based smart contracts,
                        ensuring transparency and trust.
                      </li>
                      <li className="mb-3">
                        Access funds gradually based on milestone achievements.
                      </li>

                    </ul>
                  </div>
                  <div className="mb-4">
                    <h4 className="text-white mb-4">
                      Leverage Staking Incentives:
                    </h4>
                    <ul className="mb-0">
                      <li className="mb-3">
                        Attract investors by offering staking rewards in exchange for UTX support.

                      </li>
                      <li className="mb-3">
                        Build long-term engagement with a strong investor community.
                      </li>

                    </ul>
                  </div>
                </div>
              </Col>
              <Col lg={6} className="mb-5">
                <div className="mb-5">
                  <img
                    src="assets/images/fundraising.png"
                    width={`100%`}
                    height={`450px`}
                    className="object-fit-contain"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="getintouch pt-0">
          <ConnectWallent></ConnectWallent>

          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <Button variant="primary" className="text-black" onClick={handleRedirectPage}>
                Launch Process
              </Button>
            </Col>
          </Row>

        </section>
        <Footer />
      </div>
    </>
  );
};
export default Projectowner;
